import { Button, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { AutocompleteArrayInput, SelectArrayInput, useTranslate } from 'react-admin'
import { useFieldArray, useFormContext } from 'react-hook-form'
import CloseIcon from '@mui/icons-material/Close';

export const ArrayConditions = () => {
    const translate = useTranslate()
    const [airlinesOptions, setAirlinesoptions] = useState([])
    const gds_options = [
        { id: 'all', long_name: 'Todas' },
        { id: 'AMS', long_name: 'Amadeus' },
        { id: 'SBR', long_name: 'Sabre' },
        { id: 'FBO', long_name: 'FlyBondi' },
        { id: 'NDC', long_name: 'NDC' },
        { id: 'NDX', long_name: 'NDX' }
    ]

    const { control } = useFormContext()

    const { fields, remove, append } = useFieldArray({
        control,
        name: 'air_conditions',
    })

    const getAirlines = async () =>{
        const options = await businessRuleServices.getAirlines()
        setAirlinesoptions(options)
    }

    const removeCondition = (index) =>{
        remove(index)
    }

    const appendCondition = () =>{
        append()
    }

    useEffect(()=>{
        getAirlines()
    },[])
  return (
     <Grid container spacing={3} width={'100%'}>
      {fields.map((field, index) => (
        <React.Fragment key={field.id}>
          
          <EditInputsWrap label={translate("ra.field.airline")} md={5} lg={5}>
            <AutocompleteArrayInput
              source={`air_conditions.${index}.airline`}
              choices={airlinesOptions}
              optionText="long_name"
              label={null}
              fullWidth
              optionValue="short_name"
              size="small"
            />
          </EditInputsWrap>

          <EditInputsWrap label={translate("ra.field.gds")} md={5} lg={5}>
            <AutocompleteArrayInput
              source={`air_conditions.${index}.gds`}
              choices={gds_options}
              optionText="long_name"
              label={null}
              fullWidth
              optionValue="id"
              size="small"
            />
          </EditInputsWrap>
            <EditInputsWrap  md={2} lg={2}>
                <CloseIcon onClick={()=>removeCondition(index)} style={{cursor:'pointer', alignItems:'center'}} />
            </EditInputsWrap>
        </React.Fragment>
      ))}
      <EditInputsWrap  md={12} lg={12}>
        <div style={{display:'flex', justifyContent:'flex-end'}}>
            <Button style={{justifySelf:'end'}} variant='contained' onClick={appendCondition}>
                {`${translate('ra.action.add')} ${translate('ra.field.condition')}`}
            </Button>
        </div>
      </EditInputsWrap>
    </Grid>
  )
}
